import React from "react";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer style={styles.footer}>
      <div style={styles.container}>
        <div style={styles.left}>
          © {year} Chris OnSite Auto Detailing
        </div>

        <div style={styles.right}>
          <a href="/privacy" style={styles.link}>
            Privacy Policy
          </a>
          <span style={styles.separator}>|</span>
          <a href="/terms" style={styles.link}>
            Terms of Use
          </a>
        </div>
      </div>
    </footer>
  );
};

const styles = {
  footer: {
    position: "relative",
    background: "#111",
    color: "#fff",
    padding: "16px 20px",
    marginTop: "40px",
  },
  container: {
    maxWidth: "1100px",
    margin: "0 auto",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "10px",
  },
  left: {
    fontSize: "14px",
  },
  right: {
    fontSize: "14px",
  },
  link: {
    color: "#fff",
    textDecoration: "none",
    margin: "0 6px",
  },
  separator: {
    opacity: 0.6,
  },
};

export default Footer;